import { Injectable } from '@angular/core';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root'
})

export class PdfService {

  constructor() { }

  public captureScreen(data, orientation, filename) {
    const svgElementContainer = document.querySelector('.container');
    html2canvas(svgElementContainer as HTMLElement, {
      scale: 1,
      ignoreElements: (node) => {
        return node.nodeName === 'IFRAME';
      },
      onclone: (documentClone) => {
      }
    }).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      const contentDataURL = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jspdf(orientation, 'mm', 'a4', true); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = (heightLeft - imgHeight) + 5 < 10 ? (heightLeft - imgHeight) + 5 : 5;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
        heightLeft -= pageHeight;
      }
      const date = new Date().getUTCMilliseconds();
      pdf.save(filename); // Generated PDF
    });
  }
}
